/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Grid } from "@mui/material";
import { FC, Fragment, useContext } from "react";
import { useFormik } from "formik";
import InputTextfield from "../../../../../shared/components/textField";
import { FormContainer } from "../../../../../shared/components/formContainer";
import useMutation from "../../../../../shared/components/hooks/useMutation";
import { getTextFields } from "../variables/textFields";
import ToggleSwitch from "../../../../../shared/components/switch";
import { customizeValidationSchema } from "../variables/customSchema";
import { ZSAutocomplete } from "../../../../../shared/components/autoComplete";
import useQuery from "../../../../../shared/components/hooks/useQuery";
import { SidebarContext } from "../../../../../contexts/SidebarContext";
import { Industry } from "../../../../../shared/interfaces/industry";
import { ProfileBorderBox } from "../../../../../shared/components/profileComponents";

const SkillCreate: FC = () => {
  const { loading: apiLoading, modifyData } = useMutation(
    "/master-datas/skills"
  );
  const { payload, setPayload } = useContext(SidebarContext);

  const { data } = useQuery("/industry", {
    params: {
      ...payload,
      take: 25,
      sortOrder: "ASC",
      enabled: true,
    },
  });
  const industriesData: Industry[] = (data as any)?.items || [];
  const industries = industriesData?.map((industry: Industry) => ({
    value: industry.id,
    label: industry.name,
  }));

  const textFields = getTextFields({});

  const initialValues = {
    name: "",
    industryId: "",
    enabled: true,
  };
  const skillForm = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validateOnBlur: true,
    validationSchema: customizeValidationSchema(),
    onSubmit: async (formData: any) => {
      modifyData(
        `/skill`,
        "post",
        {
          ...formData,
        },
        skillForm
      );
    },
  });
  const titleBar = {
    headerTitle: "Skill - Create",
    title: "Create Skill",
    buttonTitle: "Save",
    onClick: () => skillForm.handleSubmit(),
    dirty: skillForm.dirty,
    buttonLoading: apiLoading,
  };

  return (
    <>
      <ProfileBorderBox>
        <FormContainer titleBar={titleBar}>
          <Box className="border-custom">
            <Grid
              container
              alignItems="stretch"
              columnSpacing={4}
              rowSpacing={2}
            >
              <Grid item xs={12}>
                <ToggleSwitch
                  status={skillForm?.values?.enabled}
                  handleChange={() =>
                    skillForm.setFieldValue(
                      "enabled",
                      !skillForm?.values?.enabled
                    )
                  }
                />
              </Grid>

              {textFields.map((field: any, index: number) => (
                <Fragment key={field.id}>
                  {(field?.formField === undefined ||
                    field.formField === true) && (
                    <Grid item md={6} sm={6} xs={12}>
                      <InputTextfield
                        form={skillForm}
                        fieldProps={field}
                        key={index}
                      />
                    </Grid>
                  )}
                </Fragment>
              ))}
              <Grid item md={6} sm={6} xs={12}>
                <ZSAutocomplete
                  options={industries}
                  label="Industry"
                  placeholder="Select Industry"
                  required
                  setValue={(selectedOption: any) => {
                    skillForm.setFieldTouched("industryId", true);
                    if (selectedOption?.value) {
                      skillForm.setFieldValue(
                        "industryId",
                        selectedOption?.value
                      );
                    } else {
                      skillForm.setFieldValue("industryId", []);
                    }
                  }}
                  form={{ ...skillForm, name: "industryId" }}
                  refetchFunction={(searchString: string) => {
                    setPayload((prevData: any) => {
                      return { ...prevData, search: searchString };
                    });
                  }}
                  setBlur={() => {
                    skillForm.setFieldTouched("industryId", true);
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        </FormContainer>
      </ProfileBorderBox>
    </>
  );
};
export default SkillCreate;
